export enum LANGUAGE {
    ENGLISH = "en",
    GREEK = "el",
}
